module.exports = __webpack_public_path__ + "static/media/icon-save.bd255d67.svg";